import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4.5","key":"svg-0"}],["path",{"d":"M16 3v4","key":"svg-1"}],["path",{"d":"M8 3v4","key":"svg-2"}],["path",{"d":"M4 11h16","key":"svg-3"}],["path",{"d":"M17 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-4"}],["path",{"d":"M22 22a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2","key":"svg-5"}]]

const IconCalendarUser = createReactComponent('outline', 'calendar-user', 'CalendarUser', __iconNode);

export default IconCalendarUser;